module.exports = __webpack_public_path__ + "img/country-content-bg.76ffb354.png";